import { Flex, Text } from 'vvs-uikit'
import PixelatedImage from 'views/VvsGotchi/components/PixelatedImage'
import GotchiActionButton from 'views/VvsGotchi/components/ActionButton'
import { useTranslation } from 'contexts/Localization'

import { GachaponOption } from '../types'

import { GachaponResultModalFlex, ModalTitleIcon } from './styles'

const GachaponResult: React.FC<{
  onDismiss: () => any
  selection: GachaponOption
  resultPoints: number
}> = ({ onDismiss, selection, resultPoints }) => {
  const { t } = useTranslation()

  return (
    <GachaponResultModalFlex>
      <Flex justifyContent="center">
        <ModalTitleIcon src="/images/vvsGotchi/gachapon-icon.png" />
      </Flex>
      <Flex p={3} flexDirection="column">
        <Text mt={3} color="black" fontSize="13px" fontWeight="700" textAlign="center">
          {t('Each Mole in your team will earn:')}
        </Text>
        <Flex justifyContent="center" alignItems="center">
          <PixelatedImage
            src={selection === 'hp' ? '/images/vvsGotchi/mole_exercise.png' : '/images/vvsGotchi/star.png'}
            height="40px"
          />
          <Text ml={2} color="black" fontSize="37px" fontWeight="400">
            {selection === 'hp'
              ? t('+%resultPoints% HP', { resultPoints })
              : t('+%resultPoints% EXP', { resultPoints })}
          </Text>
        </Flex>
        <PixelatedImage mx={2} my={4} src="/images/vvsGotchi/gachapon-opened.png" />
        <GotchiActionButton onClick={onDismiss}>{t('Got it!')}</GotchiActionButton>
      </Flex>
    </GachaponResultModalFlex>
  )
}

export default GachaponResult
